// extracted by mini-css-extract-plugin
export default {"reset__input":"styles_reset__input__NUgqn"};